import PropTypes from 'prop-types';
import React from 'react';

const Illustration = props => (
    <div className={props.class}>
        <div className="image-wrapper">
            {props.isBlurred && <div className="image-overlay" />}
            <img
                src={props.url}
                alt={props.altText}
                className={props.imageClass}
                onError={props.onImageLoadError}
            />
        </div>
        {props.caption !== '' && <div className="caption">{props.caption}</div>}
    </div>
);

Illustration.propTypes = {
    url: PropTypes.string.isRequired,
    class: PropTypes.string,
    imageClass: PropTypes.string,
    altText: PropTypes.string,
    caption: PropTypes.string,
    onImageLoadError: PropTypes.func,
    isBlurred: PropTypes.bool,
};

Illustration.defaultProps = {
    altText: '',
    class: '',
    imageClass: '',
    caption: '',
    onImageLoadError: () => {},
    isBlurred: false,
};

export default Illustration;
